/* global EventBus */
import Icon from './Icon'

export default {
    data () {
        return {
            open: false,
            extended: false
        }
    },

    created () {
        EventBus.$on('AppClick', (event) => {
            if (!this.$el.contains(event.target)) {
                this.close()
            }
        })
    },

    methods: {
        toggle () {
            this.open = !this.open
        },

        close () {
            this.open = false
        },

        toggleExtension () {
            this.extended = !this.extended
        }
    },

    components: {
        Icon
    }
}
